var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalysesJar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0H3.5C2.70435 0 1.94129 0.31607 1.37868 0.87868C0.81607 1.44129 0.5 2.20435 0.5 3V6C0.5 6.79565 0.81607 7.55871 1.37868 8.12132C1.94129 8.68393 2.70435 9 3.5 9V25.5C3.5 26.6935 3.97411 27.8381 4.81802 28.682C5.66193 29.5259 6.80653 30 8 30H20C21.1935 30 22.3381 29.5259 23.182 28.682C24.0259 27.8381 24.5 26.6935 24.5 25.5V9C25.2957 9 26.0587 8.68393 26.6213 8.12132C27.1839 7.55871 27.5 6.79565 27.5 6V3C27.5 2.20435 27.1839 1.44129 26.6213 0.87868C26.0587 0.31607 25.2957 0 24.5 0ZM21.5 21H12.5V15H21.5V21ZM21.5 12H11C10.6022 12 10.2206 12.158 9.93934 12.4393C9.65804 12.7206 9.5 13.1022 9.5 13.5V22.5C9.5 22.8978 9.65804 23.2794 9.93934 23.5607C10.2206 23.842 10.6022 24 11 24H21.5V25.5C21.5 25.8978 21.342 26.2794 21.0607 26.5607C20.7794 26.842 20.3978 27 20 27H8C7.60218 27 7.22065 26.842 6.93934 26.5607C6.65804 26.2794 6.5 25.8978 6.5 25.5V9H21.5V12ZM3.5 6V3H24.5V6H3.5Z",
    fill: "#1D1E2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysesJar);
export default __webpack_public_path__ + "static/media/analyses-jar.58136719d271a83c28bb96a725e40714.svg";
export { ForwardRef as ReactComponent };